import { render, staticRenderFns } from "./MyPromoteOrder.vue?vue&type=template&id=200a27ec&"
import script from "./MyPromoteOrder.vue?vue&type=script&lang=js&"
export * from "./MyPromoteOrder.vue?vue&type=script&lang=js&"
import style0 from "./MyPromoteOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports